import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Flex, Text, Button } from "@jsq/ds/core";
import { useFeatureFlag } from "@jsq/flags-react";
import {
  PayableWorkflow,
  PaymentsListWorkflow,
  triggerPaymentBatchesRefresh,
} from "@jsq/payments-components";
import { useAppContext } from "~/contexts/appContext";
import { globalEnv } from "~/global-env";
import { hasTreasuryAccessOnAnyArena, isTreasuryUser } from "~/utils/userRoles";
import { paymentsHeader, paymentsTableContainer } from "./styles_vanilla.css";

type PaymentsPageParams = {
  paymentBatchId?: string;
};

const PaymentsPage: React.FC = () => {
  const { paymentBatchId } = useParams<PaymentsPageParams>();
  const history = useHistory();
  const [showWorkflow, setShowWorkflow] = useState(false);

  const handleCreatePaymentClick = () => {
    setShowWorkflow(true);
  };

  const handleWorkflowExit = () => {
    setShowWorkflow(false);
  };

  const handleWorkflowComplete = () => {
    setShowWorkflow(false);
    triggerPaymentBatchesRefresh();
  };

  const handleBatchSelected = (batchId?: string) => {
    if (batchId) {
      history.push(`${globalEnv.treasuryRoute}/payments/${batchId}`);
    }
  };

  const handleSlideoutClose = () => {
    history.push(`${globalEnv.treasuryRoute}/payments`);
  };

  const { user } = useAppContext();
  const isM3Enabled = useFeatureFlag("treasuryPaymentIntegration", false);
  const clientLevelPermissionsEnabled = useFeatureFlag("treasuryClientLevelPermissions", false);

  const paymentsContext = {
    isGPX: false,
    // all canopy treasury users can approve payments from a permissions perspective
    hasApprovePaymentPermission: clientLevelPermissionsEnabled
      ? hasTreasuryAccessOnAnyArena(user.roles)
      : isTreasuryUser(user.roles),
    currentUserId: user.id,
    isM3Enabled,
  };

  return (
    <>
      <Flex className={paymentsTableContainer}>
        <Flex className={paymentsHeader}>
          <Text variant="h2">Payments</Text>
          <Button icon="plus" isInline onClick={handleCreatePaymentClick}>
            Create new payment
          </Button>
        </Flex>
        <PaymentsListWorkflow
          paymentsContext={paymentsContext}
          selectedBatchId={paymentBatchId}
          onBatchSelected={handleBatchSelected}
          onSlideoutClose={handleSlideoutClose}
        />
      </Flex>
      {showWorkflow && (
        <PayableWorkflow onExit={handleWorkflowExit} onComplete={handleWorkflowComplete} />
      )}
    </>
  );
};

export default PaymentsPage;
